import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';


export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      toast.success('¡Bienvenido de nuevo!');
      navigate('/');
    } else {
      toast.error(result.error === 'Incorrect email or password' ? 'Correo o contraseña incorrectos' : result.error);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      {/* Brand Panel */}
      <div className="hidden md:flex flex-col justify-center items-center p-12 bg-hero-soft-champagne">
        <div className="max-w-md">
          <img
            src="https://images.unsplash.com/photo-1640869116016-93c00ba94b28?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=85"
            alt="Perfume"
            className="w-full h-auto rounded-lg shadow-lg mb-6"
          />
          <h1 className="text-4xl font-bold mb-4" data-font="display">Aurelia Scent OS</h1>
          <p className="text-lg text-muted-foreground">Gestión elegante de perfumerías para tu negocio</p>
        </div>
      </div>

      {/* Auth Form */}
      <div className="flex items-center justify-center p-6 sm:p-12">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle data-font="display">Bienvenido</CardTitle>
            <CardDescription>Inicia sesión en tu cuenta</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleLogin} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Correo Electrónico</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="tu@ejemplo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="auth-email-input"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Contraseña</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="auth-password-input"
                />
              </div>
              <Button
                type="submit"
                className="w-full bg-[hsl(var(--primary))] hover:bg-[#BFA774] transition-colors"
                disabled={loading}
                data-testid="auth-submit-button"
              >
                {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
